import React from "react";
import SingleColumnTemplate from "./SingleColumnTemplate";
import SidebarTemplate from "./SidebarTemplate";
import PhotoHeaderTemplate from "./PhotoHeaderTemplate";
import DarkExecutiveTemplate from "./DarkExecutiveTemplate";
import TwoColumnTemplate from "./TwoColumnTemplate";
import TimelineTemplate from "./TimelineTemplate";
import GeometricTemplate from "./GeometricTemplate";
import BannerTemplate from "./BannerTemplate";
import CompactGridTemplate from "./CompactGridTemplate";
import CorporateTemplate from "./CorporateTemplate";
import SkillBarsTemplate from "./SkillBarsTemplate";
import DiagonalTemplate from "./DiagonalTemplate";
import MonogramTemplate from "./MonogramTemplate";
import ExecutiveSerifTemplate from "./ExecutiveSerifTemplate";
import BoldHeaderSplitTemplate from "./BoldHeaderSplitTemplate";
import MinimalLineTemplate from "./MinimalLineTemplate";
import PhotoCircleSidebarTemplate from "./PhotoCircleSidebarTemplate";
import StatsGridTemplate from "./StatsGridTemplate";
import NewspaperTemplate from "./NewspaperTemplate";
import GradientWaveTemplate from "./GradientWaveTemplate";
import BoxedModernTemplate from "./BoxedModernTemplate";
import IvyLeagueTemplate from "./IvyLeagueTemplate";
import TechMonoTemplate from "./TechMonoTemplate";
import IconRowTemplate from "./IconRowTemplate";
import SplitHeaderDuoTemplate from "./SplitHeaderDuoTemplate";
import SkillRingsTemplate from "./SkillRingsTemplate";
import LeftAccentBarTemplate from "./LeftAccentBarTemplate";
import CardTimelineTemplate from "./CardTimelineTemplate";
import MagazineCoverTemplate from "./MagazineCoverTemplate";
import PillCloudTemplate from "./PillCloudTemplate";
import ZigzagTimelineTemplate from "./ZigzagTimelineTemplate";
import WaveBottomTemplate from "./WaveBottomTemplate";
import IconSidebarTemplate from "./IconSidebarTemplate";
import LedgerLinesTemplate from "./LedgerLinesTemplate";
import FramedBorderTemplate from "./FramedBorderTemplate";
import DualBalancedTemplate from "./DualBalancedTemplate";
import NumberedSectionsTemplate from "./NumberedSectionsTemplate";
import ArcHeaderTemplate from "./ArcHeaderTemplate";
import { getAccentHex } from "./templateConfig";

export const LAYOUT_MAP = {
  modern: { Component: SingleColumnTemplate, variant: "modern" },
  classic: { Component: SingleColumnTemplate, variant: "classic" },
  minimal: { Component: SingleColumnTemplate, variant: "minimal" },
  sidebar: { Component: SidebarTemplate },
  photo: { Component: PhotoHeaderTemplate },
  dark: { Component: DarkExecutiveTemplate },
  twocol: { Component: TwoColumnTemplate },
  timeline: { Component: TimelineTemplate },
  geometric: { Component: GeometricTemplate },
  banner: { Component: BannerTemplate },
  compact: { Component: CompactGridTemplate },
  corporate: { Component: CorporateTemplate },
  skillbars: { Component: SkillBarsTemplate },
  diagonal: { Component: DiagonalTemplate },
  monogram: { Component: MonogramTemplate },
  execserif: { Component: ExecutiveSerifTemplate },
  boldheader: { Component: BoldHeaderSplitTemplate },
  minimalline: { Component: MinimalLineTemplate },
  photocircle: { Component: PhotoCircleSidebarTemplate },
  statsgrid: { Component: StatsGridTemplate },
  newspaper: { Component: NewspaperTemplate },
  gradientwave: { Component: GradientWaveTemplate },
  boxedmodern: { Component: BoxedModernTemplate },
  ivyleague: { Component: IvyLeagueTemplate },
  techmono: { Component: TechMonoTemplate },
  iconrow: { Component: IconRowTemplate },
  splitheaderduo: { Component: SplitHeaderDuoTemplate },
  skillrings: { Component: SkillRingsTemplate },
  leftaccentbar: { Component: LeftAccentBarTemplate },
  cardtimeline: { Component: CardTimelineTemplate },
  magazinecover: { Component: MagazineCoverTemplate },
  pillcloud: { Component: PillCloudTemplate },
  zigzagtimeline: { Component: ZigzagTimelineTemplate },
  wavebottom: { Component: WaveBottomTemplate },
  iconsidebar: { Component: IconSidebarTemplate },
  ledgerlines: { Component: LedgerLinesTemplate },
  framedborder: { Component: FramedBorderTemplate },
  dualbalanced: { Component: DualBalancedTemplate },
  numberedsections: { Component: NumberedSectionsTemplate },
  archeader: { Component: ArcHeaderTemplate },
};

export default function TemplateRenderer({ templateId, colorId, draft }) {
  const accent = getAccentHex(colorId);
  const { Component, variant } = LAYOUT_MAP[templateId] || LAYOUT_MAP.modern;
  return <Component draft={draft} accent={accent} variant={variant} />;
}
